import { combineReducers } from "@reduxjs/toolkit";
import accountSetupReducer from "../slice/accountSetupSlice";
import authReducer from "../slice/authSlice";
import snackbarReducer from "../slice/snackbarSlice";
import selectionsReducers from "../slice/selectionsSlice";
import dataReducers from "../slice/dataSlice";
import flagSliceReducer from "../slice/flagSlice";
import userReducer from "../slice/userSlice";
import searchTextReducer from "../slice/searchSlice";
import reportTemplateReducer from "../slice/reportTemplateSlice";
import smartSearchReducer from "../slice/smartSearchSlice";
import kpiDashboardReducer from "../slice/kpiDashboardSlice";
import brain from "../slice/brainSlice";
import harbor from "../slice/harborSlice";

export default combineReducers({
  auth: authReducer,
  accountSetup: accountSetupReducer,
  snackbar: snackbarReducer,
  selections: selectionsReducers,
  data: dataReducers,
  flagSlice: flagSliceReducer,
  user: userReducer,
  searchText: searchTextReducer,
  reportTemplate: reportTemplateReducer,
  smartSearch: smartSearchReducer,
  kpiDashboard: kpiDashboardReducer,
  brain: brain,
  harbor: harbor
});
